"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockingModal = void 0;
const react_1 = __importDefault(require("react"));
const LPulse_1 = __importDefault(require("../../../components/loading/LPulse"));
function BlockingModal(props) {
    const { message, progress } = props;
    return (react_1.default.createElement("div", { className: "tab-layout--modal glx-flex-c glx-flex-center glx-no-select glx-flex-g-12 glx-animation-fade-in-super-fast" },
        react_1.default.createElement("div", null,
            react_1.default.createElement(LPulse_1.default, null)),
        react_1.default.createElement("div", null, message),
        react_1.default.createElement("div", null, progress)));
}
exports.BlockingModal = BlockingModal;
BlockingModal.defaultProps = {
    progress: undefined,
};
